import CreatorSidebar from "../components/CreatorSidebar";


const CreatorLayout = () => {
  return (
    <div className="creator-layout">
      <CreatorSidebar />
      {/* <CreatorSidebar /> */}
      <div className="creator-main">
        {/* <CreatorHeader /> */}

        <div className="creator-content">
          {/* <Outlet /> */}
        </div>
      </div>
    </div>
  );
};

export default CreatorLayout;